import { render, staticRenderFns } from "./OrderViewBreadcrumb.vue?vue&type=template&id=0161f123"
import script from "./OrderViewBreadcrumb.vue?vue&type=script&lang=js"
export * from "./OrderViewBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports